import actions from "@/store/actions/ins_user_info_action";
import mutations from "@/store/mutations/ins_user_info_mutation";
import getters from "@/store/getters/ins_user_info_getters";
export interface InsUserInfo {
  user_id: string;
  user_type: "login" | "search";
  fetch_status: "fetching" | "failed" | "idle";
  fetched: boolean;
  ins_user_info: {
    profile_pic_url: string;
    is_private: boolean;
    user_name: string;
    full_name: string;
    follower_count: number;
    media_count: number | undefined;
    has_anonymous_profile_picture: boolean | undefined;
  };
}
export interface UpdateInsUserInfo {
  userInfo: InsUserInfo;
  isDelete?: boolean | undefined;
}

interface InsUserInfoList {
  ins_user_info_list: InsUserInfo[];
}

export const state: () => InsUserInfoList = () => ({
  ins_user_info_list: []
});

export default {
  state,
  actions,
  getters,
  mutations
};
